import React, { Component } from "react";
import PropTypes from "prop-types";

class Tab extends Component {
  
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    //onClick(label);
    var contenidoTabs = document.getElementsByClassName('form-group row');
    for (let item of contenidoTabs) {
      item.style.display = "none";
    }
    document.getElementsByClassName('form-group row')[label[0]].style.display = "block";
    
    var Tabs = document.getElementsByClassName('tab-list-item');
    for (let item of Tabs) {
      item.style.backgroundColor = "#eee";
    }
    document.getElementsByClassName('tab-list-item ' + label)[0].style.backgroundColor = "white";
  };

  render() {
    const {
      onClick,
      props: { activeTab, label },
    } = this;

    let className = "tab-list-item " + label;

    /*if (activeTab === label) {
      className += " tab-list-active";
    }*/
    return (
      <li className={className} onClick={onClick} style={label[0] === 'PANTALLA DE INICIO'?{backgroundColor: "white"}:{backgroundColor: "#eee"}}>
        {label}
      </li>
    );
  }
}

export default Tab;